<template>
  <div class="invite-record-container">
    <!-- 页面标题 -->
    <div class="page-title">我的邀请</div>
    
    <!-- 统计面板 -->
    <div class="statistics-panel">
      <div class="stat-item">
        <div class="stat-label">会员等级：</div>
        <div class="stat-value user-level" style="font-size: 24px;">{{ getLevel(inviteData.level) }}</div>
      </div>
      <div class="stat-item">
        <div class="stat-label">邀请人数：</div>
        <div class="stat-value">{{ inviteData.num }}</div>
      </div>
      <div class="stat-item">
        <div class="stat-label">已获得佣金(元)：</div>
        <div class="stat-value">{{ inviteData.totalCommissionAmount }}</div>
      </div>
      <div class="stat-item">
        <div class="stat-label">累计核销(元)：</div>
        <div class="stat-value">{{ inviteData.totalFaceValue }}</div>
      </div>
    </div>
    
    <!-- 邀请记录表格 -->
    <div class="invite-table-container">
      <el-table 
        :data="inviteRecords" 
        style="width: 100%" 
        @sort-change="handleSortChange">
        <!-- 昵称列 -->
        <el-table-column prop="nickName" label="昵称"></el-table-column>
        
        <!-- 手机号列 -->
        <el-table-column prop="mobile" label="绑定手机号码"></el-table-column>
        
        <!-- 核销金额列 -->
        <el-table-column prop="totalFaceValue" label="累计核销(元)"></el-table-column>
        
        <!-- 佣金列（可排序） -->
        <el-table-column prop="totalCommissionAmount" label="贡献佣金(元)" sortable></el-table-column>
        
        <!-- 认证状态列（带筛选） -->
        <el-table-column label="认证状态" width="150">
          <template slot="header">
            <el-dropdown trigger="click" @command="filterByStatus" placement="bottom">
              <span class="el-dropdown-link">
                认证状态 <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="status-dropdown-menu">
                <el-dropdown-item command="0">未认证</el-dropdown-item>
                <el-dropdown-item command="1">已认证</el-dropdown-item>
                <el-dropdown-item command="">全部</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            {{ scope.row.isContract == 0 ? '未认证' : '已认证' }}
          </template>
        </el-table-column>
        
        <!-- 注册时间列 -->
        <el-table-column prop="registerTime" label="时间"></el-table-column>
      </el-table>
      
      <!-- 分页器 -->
      <div class="pagination-container">
        <pagination 
          v-show="total > 0" 
          :total="total" 
          :page.sync="form.pageNum" 
          :limit.sync="form.pageSize"
          @pagination="getInviteList()" />
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http/axios";

export default {
  name: "BatchList",
  props: {
    // 批次号（如果有）
    batchNo: {
      type: String,
      default: ''
    }
  },
  
  data() {
    return {
      // 邀请统计数据
      inviteData: {
        level: 1,
        num: 0,
        totalCommissionAmount: 0,
        totalFaceValue: 0
      },
      // 邀请记录列表
      inviteRecords: [],
      // 总记录数
      total: 0,
      // 查询参数
      form: {
        pageNum: 1,        // 当前页码
        pageSize: 10,      // 每页条数
        sortType: null,    // 排序类型：1-升序，2-降序
        status: null       // 认证状态：0-未认证，1-已认证，null-全部
      }
    }
  },
  
  mounted() {
    // 初始化数据
    this.getInviteCount();
    this.getInviteList();
  },
  
  methods: {
    /**
     * 获取邀请统计信息
     */
    getInviteCount() {
      http.get('/user/invite/count').then(res => {
        if (res.code === 200) {
          this.inviteData = res.data;
        }
      });
    },
    
    /**
     * 获取邀请列表数据
     */
    getInviteList() {
      http.get('/user/invite/list', {
        params: this.form
      }).then(res => {
        if (res.code === 200) {
          this.inviteRecords = res.rows;
          this.total = res.total;
        }
      });
    },

    /**
     * 认证状态筛选处理
     * @param {String} command 筛选命令：0-未认证，1-已认证，空字符串-全部
     */
    filterByStatus(command) {
      if (command === "") {
        this.form.status = null;
      } else {
        this.form.status = command;
      }
      // 重置页码并重新加载数据
      this.form.pageNum = 1;
      this.getInviteList();
    },
    
    /**
     * 表格排序变化处理
     * @param {Object} column 排序列信息
     */
    handleSortChange(column) {
      if (!column.order) {
        this.form.sortType = null;
      } else if (column.order === 'ascending') {
        this.form.sortType = 1; // 升序
      } else {
        this.form.sortType = 2; // 降序
      }
      this.getInviteList();
    },
    
    /**
     * 根据等级获取会员等级名称
     * @param {Number} level 等级值
     * @returns {String} 等级名称
     */
    getLevel(level) {
      const levelMap = {
        1: '普通用户',
        2: '银牌组长',
        3: '金牌团长',
        4: '钻石精英'
      };
      return levelMap[level] || '普通用户';
    }
  }
}
</script>

<style scoped lang="less">
.invite-record-container {
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  padding: 0;
  height: 174px;
  margin-top: 20px;

  // 页面标题样式
  .page-title {
    font-size: 18px;
    font-weight: 500;
    color: #333;
    height: 54px;
    line-height: 54px;
    text-align: left;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 10px;
    padding: 0 34px;
  }

  // 统计面板样式
  .statistics-panel {
    background-color: #fff;
    height: calc(174px - 54px - 11px);
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 0 34px;

    // 统计项样式
    .stat-item {
      display: flex;
      flex-direction: column;
      margin-right: 74px;

      &:last-child {
        margin-right: 0;
      }

      .stat-label {
        color: #666;
        font-size: 14px;
        margin-bottom: 8px;
      }

      .stat-value {
        color: #333;
        font-size: 24px;
        margin-top: 5px;

        &.user-level {
          min-width: 80px;
        }
      }
    }
  }

  // 表格容器样式
  .invite-table-container {
    background-color: #fff;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
    margin-top: 20px;
    width: 100%;
    
    // 分页容器样式
    .pagination-container {
      display: flex;
      justify-content: flex-end;
      padding-right: 30px;
      margin-top: 15px;
    }
  }

  // 表格样式覆盖
  /deep/ .el-table {
    th {
      background-color: #f7f8fa;
      padding: 12px 20px;
      font-size: 14px;
      font-weight: 500;
      color: #333;
    }

    td {
      padding: 16px 20px;
      font-size: 14px;
      color: #333;
    }
  }

  // 下拉菜单样式
  /deep/ .el-dropdown-link {
    cursor: pointer;
    color: #333;
    display: flex;
    align-items: center;
  }

  /deep/ .status-dropdown-menu {
    min-width: 120px;
  }
}
</style>